import { Component, DestroyRef, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { TranslocoDirective } from '@jsverse/transloco';
import { Icons } from '../../../../../util/Icons';
import { LayoutService } from '../../../../../../@vex/services/layout.service';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { CostGroup, CostGroupService } from '@eadsysteme/billingclient-v1';
import { SessionService } from '../../../../../services/session.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SnackbarService } from '../../../../../services/snackbar.service';
import { LocaleHelper } from '../../../../../util/LocaleHelper';
import { CookieService } from 'ngx-cookie-service';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';

@Component({
	selector: 'vex-cost-group-type-dialog',
	imports: [
		MatButton,
		MatDialogActions,
		MatIcon,
		MatDialogContent,
		MatDialogTitle,
		TranslocoDirective,
		FormsModule,
		MatFormField,
		MatInput,
		MatLabel,
		ReactiveFormsModule,
		CdkDrag,
		CdkDragHandle,
		MatIconButton,
	],
	templateUrl: './cost-group-type-dialog.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: './cost-group-type-dialog.component.scss',
})
export class CostGroupTypeDialogComponent {
	dialogRef = inject<MatDialogRef<CostGroupTypeDialogComponent>>(MatDialogRef);
	dialogData = inject(MAT_DIALOG_DATA);
	protected icons = inject(Icons);
	protected layoutService = inject(LayoutService);
	private readonly snackBar = inject(SnackbarService);
	private readonly costGroupService = inject(CostGroupService);
	private readonly sessionService = inject(SessionService);
	private readonly formBuilder = inject(FormBuilder);

	private destroyRef = inject(DestroyRef);
	private cookieService = inject(CookieService);
	protected costGroupFg: FormGroup;
	private readonly billingId: string;
	private readonly billingPeriodId: string;
	private selectedCostGroupType: CostGroup;

	constructor() {
		const dialogData = this.dialogData;

		this.billingId = dialogData.billingId;
		this.billingPeriodId = dialogData.billingPeriodId;
		this.selectedCostGroupType = dialogData.costGroupType;
		this.costGroupFg = this.formBuilder.group({
			name: [{ value: this.selectedCostGroupType.name, disabled: false }, Validators.required],
			printName: [{ value: this.selectedCostGroupType.printname, disabled: false }, Validators.required],
			description: [{ value: this.selectedCostGroupType.description, disabled: false }],
		});
	}

	close(saved: boolean): void {
		if (!saved) {
			this.dialogRef.close();
			return;
		}
		this.selectedCostGroupType.name = this.costGroupFg.get('name').value;
		this.selectedCostGroupType.printname = this.costGroupFg.get('printName').value;
		this.selectedCostGroupType.description = this.costGroupFg.get('description').value;
		this.costGroupService
			.updateCostGroup(this.sessionService.effectiveArea, this.billingId, this.selectedCostGroupType.exportId, this.selectedCostGroupType)
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe({
				next: () => {
					this.dialogRef.close();
				},
				error: (err) => {
					const currentLanguage = LocaleHelper.localeToLanguage(this.cookieService.get('locale'));
					this.snackBar.error(err.error.errorDescription.errorDetails[currentLanguage]);
				},
			});
	}
}
